/**
 * Ko-fiサポートボタンコンポーネント
 *
 * 開発者へのサポートを促すフローティングボタン
 */

import { useState } from 'react';

// Ko-fiのURL（後で設定）
const KOFI_URL = 'https://ko-fi.com/knovelo';

function KofiButton() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="fixed bottom-4 right-4 z-30 lg:right-[420px]">
      {/* 展開されたメッセージ */}
      {isExpanded && (
        <div className="absolute bottom-16 right-0 w-64 bg-white rounded-2xl shadow-xl p-4 mb-2 fade-in">
          <button
            onClick={() => setIsExpanded(false)}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
          <p className="text-sm text-gray-600 mb-3">
            KnoVeloを気に入っていただけましたか？<br />
            開発を応援していただけると嬉しいです！
          </p>
          <a
            href={KOFI_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center py-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-white font-semibold rounded-xl hover:opacity-90 transition-opacity"
          >
            ☕ コーヒーで応援する
          </a>
        </div>
      )}

      {/* フローティングボタン */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-12 h-12 bg-gradient-to-r from-yellow-400 to-orange-500 text-white rounded-full shadow-lg flex items-center justify-center hover:scale-110 transition-transform"
        title="開発者を応援する"
      >
        <span className="text-xl">☕</span>
      </button>
    </div>
  );
}

export default KofiButton;
